import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { FaHome, FaBriefcase, FaProjectDiagram, FaLayerGroup, FaRobot, FaChalkboard } from "react-icons/fa";
import styles from "./NavigationBar.module.css";

const NavigationBar = (props) => {
  return (
    <Navbar
      variant="dark"
      className={styles.modernNavbar}
      fixed="top"
    >
      <Container fluid>
        <Nav
          className={`mx-auto ${styles.navLinks}`}
          activeKey={props.currentTab}
          onSelect={(key) => props.setCurrentTab(key)}
        >
          <Nav.Link
            eventKey="home"
            className={
              props.currentTab === "home"
                ? styles.activeLink
                : styles.inactiveLink
            }
          >
            <FaHome className={styles.navIcon} />
            <span className={styles.navLabel}>Home</span>
          </Nav.Link>
          <Nav.Link
            eventKey="experience"
            className={
              props.currentTab === "experience"
                ? styles.activeLink
                : styles.inactiveLink
            }
          >
            <FaBriefcase className={styles.navIcon} />
            <span className={styles.navLabel}>Experience</span>
          </Nav.Link>
          <Nav.Link
            eventKey="projects"
            className={
              props.currentTab === "projects"
                ? styles.activeLink
                : styles.inactiveLink
            }
          >
            <FaProjectDiagram className={styles.navIcon} />
            <span className={styles.navLabel}>Projects</span>
          </Nav.Link>
          <Nav.Link
            eventKey="techstack"
            className={
              props.currentTab === "techstack"
                ? styles.activeLink
                : styles.inactiveLink
            }
          >
            <FaLayerGroup className={styles.navIcon} />
            <span className={styles.navLabel}>Tech Stack</span>
          </Nav.Link>
          <a
            href="https://blackboard.parasjain.pro"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.blackboardLink}
          >
            <FaChalkboard className={styles.navIcon} />
            <span className={styles.navLabel}>Blackboard</span>
            <span className={styles.newBadge}>NEW</span>
          </a>
          <a
            href="https://facesnap.parasjain.pro"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.facesnapLink}
          >
            <FaRobot className={styles.navIcon} />
            <span className={styles.navLabel}>FaceSnap</span>
            <span className={styles.hotBadge}>HOT AI</span>
          </a>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
